// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__QRowd","label":"CategoryService_label__5CyYH","location":"CategoryService_location__274Mf"};